<template>
  <v-menu bottom offset-y max-height="80vh" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        outlined
        :elevation="0"
        class="mt-1 px-1"
        style="min-width: 30px"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon small>mdi-table-column-width</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item
        v-for="(campo, i) in camposVisiblesEnTabla"
        :key="i"
        link
        :disabled="campo.obligatorio"
        @click="conmutarVisibilidadCampo (campo)"
      >
        <v-list-item-icon class="mr-1">
          <v-icon v-if="campo.oculto" color="gray">mdi-checkbox-blank-outline</v-icon>
          <v-icon v-else color="gray">mdi-checkbox-marked</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ campo.titulo }}</v-list-item-title>
      </v-list-item>
    </v-list>

    <v-card :elevation="0" flat style="margin-top: -1px" color="#ddd">
      <center>
        <v-btn text small @click="todasLasColumnasClick"><v-icon small>mdi-checkbox-multiple-marked</v-icon></v-btn>
        <v-btn text small @click="ningunaColumnaClick"><v-icon small>mdi-checkbox-multiple-blank-outline</v-icon></v-btn>
        <v-btn text small @click="restaurarColumnasClick"><v-icon small>mdi-backup-restore</v-icon></v-btn>
      </center>
    </v-card>

  </v-menu>
</template>

<script>

export default {
  props: {
    idTablaVista: {
      type: String,
      required: true,
    },
    definicionCampos: {
      type: Object,
      required: true,
    },
    campos: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      camposOriginal: null,
    }
  },
  computed: {
    camposVisiblesEnTabla() {
      let aux = {};
      this.campos.forEach ((campo, indice) => {
        let nombreCampo = campo;
        let obligatorio = campo.endsWith ('+');
        let oculto = campo.endsWith ('-');
        if (obligatorio || oculto)
          nombreCampo = nombreCampo.slice (0, -1);

        if (!this.definicionCampos [nombreCampo] || this.definicionCampos [nombreCampo].visibilidad == '-')
          return;

        aux [campo] = {
          titulo: this.definicionCampos [nombreCampo].titulo,
          obligatorio: obligatorio,
          oculto: oculto,
          indice: indice
        }
      })
      return aux;
    }
  },
  methods: {
    guardarConfiguracion() {
      this.$store.guardar_preferencia ('columnas', this.campos, this.camposOriginal, 'tablaDatosAPI', this.idTablaVista);
    },
    conmutarVisibilidadCampo (objetoCampo) {
      let aux = this.campos [objetoCampo.indice];
      if (aux.endsWith ('-'))
        aux = aux.slice (0, -1)
      else
        aux = aux + '-';
      this.$set (this.campos, objetoCampo.indice, aux);
      this.guardarConfiguracion();
      this.$emit ('cambios', objetoCampo);
    },
    todasLasColumnasClick () {
      this.campos.forEach((nombreCampo, indice) => {
        if (nombreCampo.endsWith ('-'))
          nombreCampo = nombreCampo.slice (0, -1);
        this.$set (this.campos, indice, nombreCampo);
      });
      this.guardarConfiguracion();
      this.$emit ('cambios');
    },
    ningunaColumnaClick () {
      this.campos.forEach((nombreCampo, indice) => {
        if (!nombreCampo.endsWith ('-') && !nombreCampo.endsWith ('+'))
          nombreCampo = nombreCampo + '-';
        this.$set (this.campos, indice, nombreCampo);
      });
      this.guardarConfiguracion();
      this.$emit ('cambios');
    },
    restaurarArraycampos (arraycamposFuente) {
      arraycamposFuente.forEach((nombreCampo, indice) => {
        this.$set (this.campos, indice, nombreCampo);
      });
    },
    restaurarColumnasClick () {
      this.restaurarArraycampos (this.camposOriginal);
      this.guardarConfiguracion();
      this.$emit ('cambios');
    },
    arrayCamposACadenaFiltrada (arrayCampos) {
      let cadena = arrayCampos.join('|');
      var regex = /[\w|]+/g;
      return (cadena.match (regex) || []).join('');
    }
  },
  created() {
    this.camposOriginal = [...this.campos];
    let aux = this.$store.leer_preferencia ('columnas', this.camposOriginal, 'tablaDatosAPI', this.idTablaVista);

    if (aux && (this.arrayCamposACadenaFiltrada (this.camposOriginal) == this.arrayCamposACadenaFiltrada (aux)))
      this.restaurarArraycampos (aux);
  }

}
</script>

<style>

</style>